// Polaroids functionality - Vanilla JS animations
function initPolaroids() {
  console.log('🎬 Initializing polaroids...');
  const sections = document.querySelectorAll('section[data-images]');
  console.log('📸 Found sections with data-images:', sections.length);

  sections.forEach(section => {
    try {
      const imagesData = JSON.parse(section.getAttribute('data-images'));
      console.log('📷 Processing section:', section.className, 'with images:', imagesData);
      if (imagesData && imagesData.length > 0) {
        createPolaroids(section, imagesData);
      }
    } catch (error) {
      console.warn('Invalid images data for section:', section.className, error);
    }
  });
}

function createPolaroids(section, imagesData) {
  // Remove existing polaroids if any
  const existingPolaroids = section.querySelector('.polaroids');
  if (existingPolaroids) {
    existingPolaroids.remove();
  }

  const polaroidsContainer = document.createElement('div');
  polaroidsContainer.className = 'polaroids';




  imagesData.slice(0, 3).forEach((imageData, index) => {
    const polaroid = document.createElement('div');
    polaroid.className = 'polaroid polaroid-enter';


    const img = document.createElement('img');
    img.className = 'polaroid-image';
    img.src = imageData.src;
    img.alt = imageData.caption || '';
    img.loading = 'lazy';

    // Handle image load errors gracefully
    img.onerror = function () {
      this.style.background = '#e0e0e0';
      this.style.display = 'flex';
      this.style.alignItems = 'center';
      this.style.justifyContent = 'center';
      this.innerHTML = '<span style="color: #999; font-size: 12px;">Image not found</span>';
    };

    const caption = document.createElement('div');
    caption.className = 'polaroid-caption';
    caption.textContent = imageData.caption || '';

    polaroid.appendChild(img);
    polaroid.appendChild(caption);
    polaroidsContainer.appendChild(polaroid);

  });

  section.appendChild(polaroidsContainer);
}

// Helper functions to generate random values within ranges
function generateRandomRotations(count) {
  const rotations = [];
  for (let i = 0; i < count; i++) {
    // Random rotation between -12 and 12 degrees
    rotations.push(Math.random() * 24 - 12);
  }
  return rotations;
}

function generateRandomXOffsets(count) {
  const xOffsets = [];
  const baseOffset = -200; // Adjusted starting point
  const spacing = 200; // Spacing based on polaroid width
  const maxVariation = 180; // Reduced random variation

  for (let i = 0; i < count; i++) {
    const basePosition = baseOffset - (i * spacing);
    const randomVariation = (Math.random() - 0.5) * maxVariation;
    xOffsets.push(basePosition + randomVariation);
  }
  return xOffsets;
}

function generateRandomYOffsets(count) {
  const yOffsets = [];
  const baseOffset = -20; // Starting point moved down
  const maxDownward = 600; // Maximum downward movement
  const maxUpward = 100; // Limited upward movement
  
  for (let i = 0; i < count; i++) {
    // 70% chance to go downward, 30% chance to go upward
    const isGoingDown = Math.random() < 0.7;
    
    if (isGoingDown) {
      // Generate downward offset
      const randomVariation = Math.random() * maxDownward;
      yOffsets.push(baseOffset + randomVariation);
    } else {
      // Generate limited upward offset
      const randomVariation = Math.random() * maxUpward;
      yOffsets.push(baseOffset - randomVariation);
    }
  }
  return yOffsets;
}

// Simple, smooth animation function using CSS transitions
function animatePolaroids(section) {
  const polaroids = section.querySelectorAll('.polaroid');

  if (polaroids.length === 0) return null;

  // Animation settings - Generate random values within ranges
  const rotations = generateRandomRotations(polaroids.length);
  const xOffsets = generateRandomXOffsets(polaroids.length);
  const yOffsets = generateRandomYOffsets(polaroids.length);
  const staggerDelay = 100; // 0.1s between each polaroid

  // Animate each polaroid with staggered timing
  polaroids.forEach((polaroid, index) => {
    const rotation = rotations[index] || 0;
    const xOffset = xOffsets[index] || 0;
    const yOffset = yOffsets[index] || 0;
    const delay = index * staggerDelay;

    // Set consistent base starting position
    polaroid.style.opacity = '1';
    polaroid.style.transform = `translateX(400px) translateY(-50px) rotate(0deg) scale(0.8)`;
    polaroid.style.transition = 'all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)';

    // Start animation after delay
    setTimeout(() => {
      polaroid.style.opacity = '1';
      polaroid.style.transform = `translateX(${xOffset}px) translateY(${yOffset}px) rotate(${rotation}deg) scale(1)`;
    }, delay);
  });

  return true;
}

function hidePolaroids(section) {
  const polaroids = section.querySelectorAll('.polaroid');

  if (polaroids.length === 0) return null;

  polaroids.forEach((polaroid, index) => {
    const delay = index * 50; // 0.05s stagger for quicker exit

    polaroid.style.transition = 'all 0.4s ease-in';

      // Animate back to base position before fading out
      polaroid.style.opacity = '1';
      polaroid.style.transform = `translateX(400px) translateY(-50px) rotate(0deg) scale(0.8)`;

  });

  return true;
}

// Export functions for global access
window.initPolaroids = initPolaroids;
window.animatePolaroids = animatePolaroids;
window.hidePolaroids = hidePolaroids;